import PropTypes from 'prop-types'
import CircularProgress from '@mui/material/CircularProgress'
import { statusColors } from '../theme'

function Swatch({ color, label }) {
  return (
    <span className="d-flex align-items-center gap-1">
      <span className="legend-swatch" style={{ background: color }} />
      <span>{label}</span>
    </span>
  )
}

Swatch.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

export default function LegendBar({ layout, loading }) {
  return (
    <div className="legend-bar d-flex flex-wrap align-items-center gap-3">
      <span style={{ fontWeight: 700, textTransform: 'uppercase', color: '#555', fontSize: 11 }}>
        Legend
      </span>
      {layout === 'staff' ? (
        <>
          <Swatch color={statusColors.available.bg} label="Available" />
          <Swatch color={statusColors.partial.bg}   label="Partially booked" />
          <Swatch color={statusColors.full.bg}      label="Fully booked" />
          <Swatch color={statusColors.over.bg}      label="Overbooked" />
          <Swatch color={statusColors.exception.bg} label="Holiday / RDO" />
          <span className="ms-auto d-none d-md-block" style={{ fontSize: 11, color: '#666' }}>
            Cells show the project &amp; hours already booked that day
          </span>
        </>
      ) : (
        <>
          <Swatch color={statusColors.full.bg} label="Staff allocated" />
          <span className="ms-auto d-none d-md-block" style={{ fontSize: 11, color: '#666' }}>
            Cells show staff already booked on each project per day
          </span>
        </>
      )}
      {loading && <CircularProgress size={14} thickness={5} sx={{ ml: 1, color: 'var(--brand-color-2)' }} />}
    </div>
  )
}

LegendBar.propTypes = {
  layout:  PropTypes.string.isRequired,
  loading: PropTypes.bool,
}
LegendBar.defaultProps = { loading: false }
